import { REGISTER_CONTRACT } from './index';
import { Action } from '../action';
import { ContractForm } from '@shared/core';

export class RegisterContractInitAction implements Action {
	readonly type = REGISTER_CONTRACT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterContractDestroyAction implements Action {
	readonly type = REGISTER_CONTRACT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterContractClickSubmitAction implements Action {
	readonly type = REGISTER_CONTRACT.CLICK_SUBMIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterContractClickIgnoreAction implements Action {
	readonly type = REGISTER_CONTRACT.CLICK_IGNORE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterContractIgnoreStepAction implements Action {
	readonly type = REGISTER_CONTRACT.IGNORE_STEP;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterContractIgnoreStepSuccessAction implements Action {
	readonly type = REGISTER_CONTRACT.IGNORE_STEP_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class RegisterContractIgnoreStepFailureAction implements Action {
	readonly type = REGISTER_CONTRACT.IGNORE_STEP_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class RegisterContractFormUpdateAction implements Action {
	readonly type = REGISTER_CONTRACT.FORM_UPDATE;
	constructor(
		public payload: ContractForm,
		public correlationId?: number
	) {}
}

export class RegisterContractFormResetAction implements Action {
	readonly type = REGISTER_CONTRACT.FORM_RESET;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
